import { ref } from 'vue';

export function useDialogPromise<T>() {
    const show = ref(false);
    let submitCallback: ((data: T) => void) | undefined;
    function submit(data: T) {
        submitCallback?.(data);
    }
    function execute(): Promise<T> {
        return new Promise((resolve) => {
            submitCallback = (data) => {
                submitCallback = undefined;
                resolve(data);
            };
            show.value = true;
        });
    }

    return {
        show,
        submit,
        execute,
    };
}
